// extracted by mini-css-extract-plugin
export default {"ppt":"ContentByType_ppt__BKuJ3"};